module.exports = __webpack_public_path__ + "static/img/contactenos.aee8e4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contactenos.png
// module id = vaf1
// module chunks = 0